import {getVehicle} from "../react/datalayers/helpers";

const webInteractionOptions = {
    'userId': 'user_id',
    'optionName': 'option_name',
}

Array.from(document.querySelectorAll('[data-web-interaction-text]')).forEach((element) => {
	element.addEventListener('click', () => {
		let dataLayer = {
			event: 'web_interaction',
			web_interaction_click_text: element.dataset.webInteractionText,
		};

		if (element.dataset.webInteractionLocation) {
			Object.assign(dataLayer, {
				web_interaction_location: element.dataset.webInteractionLocation,
			});
		}

		if (element.dataset.webInteractionContentBlock) {
			Object.assign(dataLayer, {
				web_interaction_content_block: element.dataset.webInteractionContentBlock,
			});
		}

        if (element.dataset.car) {
            const vehicle = getVehicle(JSON.parse(element.dataset.car));
            Object.assign(dataLayer, vehicle);
        }

        Object.keys(webInteractionOptions).forEach((key) => {
            if (element.dataset[key]) {
                Object.assign(dataLayer, {
                    [webInteractionOptions[key]]: element.dataset[key],
                });
            }
        });

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(dataLayer);
	});
});

Array.from(document.querySelectorAll('[data-dealer-interaction-text]')).forEach((element) => {
	element.addEventListener('click', () => {
		let dataLayer = {
			event: 'dealer_interaction',
			dealer_interaction_webspace: document.body.dataset.webspace,
			dealer_interaction_click_text: element.dataset.dealerInteractionText,
			dealer_interaction_content_block: element.dataset.dealerInteractionContentBlock ? element.dataset.dealerInteractionContentBlock : 'location',
			dealer_interaction_page_type: element.dataset.dealerInteractionPageType,
			dealer: {
				dealer_name: element.dataset.dealerInteractionDealerName,
				dealer_location: element.dataset.dealerInteractionDealerLocation,
				dealer_brand: element.dataset.dealerInteractionDealerBrand,
			},
		};

        Object.keys(webInteractionOptions).forEach((key) => {
            if (element.dataset[key]) {
                Object.assign(dataLayer, {
                    [webInteractionOptions[key]]: element.dataset[key],
                });
            }
        });

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(dataLayer);
	});
});

Array.from(document.querySelectorAll('a[href^="tel:"], a[href^="mailto:"]')).forEach((element) => {
	element.addEventListener('click', () => {
		let dataLayer = {
			event: 'contact_interaction',
			contact_interaction_action: element.getAttribute('href').indexOf('tel:') !== -1 ? 'phone' : 'email',
		};

		if (document.body.dataset.pageType) {
			Object.assign(dataLayer, {
				contact_interaction_location: document.body.dataset.pageType,
			});
		}

        if (element.dataset.contactInteractionContentBlock) {
            Object.assign(dataLayer, {
                contact_interaction_content_block: element.dataset.contactInteractionContentBlock,
            });
        }

        Object.keys(webInteractionOptions).forEach((key) => {
            if (element.dataset[key]) {
                Object.assign(dataLayer, {
                    [webInteractionOptions[key]]: element.dataset[key],
                });
            }
        });

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(dataLayer);
	});
});

Array.from(document.querySelectorAll('[data-contact-interaction-action]')).forEach((element) => {
    element.addEventListener('click', () => {
        let dataLayer = {
            event: 'contact_interaction',
            contact_interaction_webspace: document.body.dataset.webspace,
            contact_interaction_action: element.dataset.contactInteractionAction,
            contact_interaction_content_block: element.dataset.contactInteractionContentBlock,
            contact_interaction_location: element.dataset.dealerInteractionLocation
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayer);
    });
});

/* Online purchase events */
const onlinePurchaseCta = document.querySelector('[data-web-interaction-online-purchase]');
if (onlinePurchaseCta) {
	onlinePurchaseCta.addEventListener('click', () => {
		const vehicle = JSON.parse(onlinePurchaseCta.dataset.vehicle);

		let dataLayer = {
			event: 'add_to_cart',
			vehicle_detail: {
				...lowerCaseVehicle(vehicle),
			},
		};

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(dataLayer);
	});
}

/* Flow events */
Array.from(document.querySelectorAll('[data-web-interaction-flow]')).forEach((flowCta) => {
    flowCta.addEventListener('click', () => {
        const vehicle = JSON.parse(flowCta.dataset.vehicle);

        let dataLayer = {
            event: 'web_interaction',
            web_interaction_click_text: flowCta.dataset.webInteractionFlowText,
            web_interaction_content_block: flowCta.dataset.webInteractionContentBlock,
            web_interaction_location: flowCta.dataset.webInteractionLocation,
            vehicle_detail: {
                ...lowerCaseVehicle(vehicle),
            },
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayer);
    });
});

const lowerCaseVehicle = (vehicle) => {
    const lowerVehicle = {}
    Object.keys(vehicle).forEach(key => {
        if (typeof vehicle[key] === 'string' || vehicle[key] instanceof String) {
            lowerVehicle[key] = vehicle[key].toLowerCase()
        } else {
            lowerVehicle[key] = vehicle[key];
        }
    });
    return lowerVehicle;
}
